import { Api } from 'vl-common/src/api';

export const getPatientDetails = (calling_guid, patient_guid) => {
  return () => Api.referrers.getPatient(patient_guid).then(({ data }) => data);
};

export default getPatientDetails;
